// Import vue stuff
// import Vue from 'vue'
// import Router from 'vue-router'
// import NotFound from '@/views/404.vue'

import { createRouter, createWebHistory } from 'vue-router'

// Vue.use(Router)

// const router = new Router({
//   mode: 'history',
//   base: process.env.BASE_URL,
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/auth/v1.0',
      name: 'Plugins Auth About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './pikle/PluginsAbout.vue'),
      // component: PluginsAbout
    },
    {
      path: '/auth/v1.0/connect',
      name: 'Plugin Connect',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "group-auth" */ './pikle/PluginConnect.vue'),
      // component: PluginConnect
    },
    {
      path: '/auth/v1.0/init',
      name: 'Plugin Service Initialization',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "group-auth" */ './pikle/PluginInit.vue'),
      // component: PluginInit
    },
    // {
    //   path: '*',
    //   component: NotFound
    // }
  ]
})

export default router
